import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
} from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { bool, number, string, func, shape } from 'prop-types';

class EditSourceModal extends Component {
  static propTypes = {
    isOpen: bool.isRequired,
    toggleModal: func.isRequired,
    onClosed: func.isRequired,
    loading: bool,
    source: shape({ id: number, title: string }),
  };

  static defaultProps = {
    isOpen: false,
    loading: false,
  };

  state = {
    source: {
      id: 0,
      title: '',
    },
    error: '',
  };

  onChange = ({ target }) => {
    this.setState((prevState) => ({
      source: {
        ...prevState.source,
        [target.name]: target.value,
      },
    }));
  };

  setSource = () => {
    this.setState(() => ({ source: this.props.source }));
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onSubmit(this.state.source);
  };

  render() {
    const { isOpen, toggleModal, onClosed, loading } = this.props;
    const { title } = this.state.source;

    return (
      <Modal
        isOpen={isOpen}
        onOpened={this.setSource}
        toggle={toggleModal}
        onClosed={onClosed}
        centered
        autoFocus
        className="edit-source-modal"
      >
        <ModalHeader toggle={toggleModal}>
          <FormattedMessage id="sources.modal.header" defaultMessage="Source editing" />
        </ModalHeader>
        <Form onSubmit={this.handleSubmit} autoComplete="off">
          <ModalBody>
            <FormGroup className="form-group-upper-label">
              <Label for="source-title" className="col-form-label">
                <FormattedMessage id="source.form.title" defaultMessage="Title" />
              </Label>
              <Input
                name="title"
                id="source-title"
                onChange={this.onChange}
                value={title}
                autoFocus
                required
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            {/* <Button className="btn-sm" color="light" onClick={toggleModal}>
              <FormattedMessage id="main.cancel" defaultMessage="Cancel" />
            </Button> */}
            <Button className="btn-sm" type="submit" disabled={!title || loading} color="primary">
              <FormattedMessage id="main.save" defaultMessage="Save" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    );
  }
}

export default EditSourceModal;
